
import React from 'react'
import AuditDataListfromApi from '../../components/AuditDataListfromApi'

export default function CreditSummery() {
  return (
   
      // <div
      //   style={{
      //     borderRadius: '4px',
      //     // background:'#42a1ad',
      //   }}
      // >
       <AuditDataListfromApi
        endpoint="/credit"
        headerText="Credit Data Report"
      />
      // </div>
    
  )
}

 